module.exports = __webpack_public_path__ + "img/a3.013bb3c5.png";